import { CSSProperties } from 'react';

import Icon from '@ui/icons/icon';
import { IconProps } from '@ui/icons/types';

const RotatableIcon = ({ rotate, ...rest }: IconProps & { rotate: CSSProperties['rotate'] }) => {
  return (
    <div
      className="flex ai-center jc-center"
      style={{
        transition: 'transform 0.2s ease-in-out',
        transform: `rotate(${rotate})`,
      }}
    >
      <Icon {...rest} />
    </div>
  );
};

export default RotatableIcon;
